import React from "react";
import ColorPicker from "../components/ColorPicker";

export function renderColorPickers({ config, data, onUpdated }) {
  return config.map(({ title, key }) => (
    <div key={key}>
      <ColorPicker
        title={title}
        color={data[key]}
        onColorSelected={(color) => {
          data[key] = color;
          onUpdated(data);
        }}
      />
      <br />
    </div>
  ));
}
